<template>
  <section >
    {{text}}
    <!--
    <div v-if="show_button" class="mt-1 mb-1 betterplace-widget">
      <a title="Donate for “GlobalSocial - network” on betterplace.org!" target="_blank"  class="no-deco" href="https://www.betterplace.org/de/donate/platform/projects/80075-globalsocial-network?utm_campaign=donate_btn&utm_content=project%2380075&utm_medium=external_banner&utm_source=projects"><img style="border:0px" alt="Donate now! This donation form is provided by betterplace.org." width="160" height="100" src="https://betterplace-assets.betterplace.org/static-images/projects/donation-button-de.png" /></a>
    </div>
-->
    <div class="mb-3">
      <!--<h3 v-if="show_header" class="text-center">JETZT Direkt spenden an</h3> -->
      <RTDonateList v-if="!directDonation" :project="project" :stream_id="stream_id" :show_total_donations="show_total_donations" :limit="limit" :emailRequired="limit >= 0" :enableStreamNameOption="enableStreamNameOption"/>
      
      <!-- GSN -->
      <div v-else class="text-center" >
        <a title="Spenden an Global Social Network" target="_blank" class=" no-deco donate" rel="noreferrer" href="https://www.globalsocial-network.org/jetzt-spenden/"><img alt="Global Social network" src="/images/logo_GlobalSocial.png"></a>
        <br><a title="Spenden an Global Social Network" target="_blank" class="button gsn-donate-button" rel="noreferrer" href="https://www.globalsocial-network.org/jetzt-spenden/">JETZT UNTERSTÜTZEN</a>
      </div>
      <!-- Betterplace-->
      <!--<a title="Donate for “GlobalSocial - network” on betterplace.org!" target="_blank"  class="no-deco" href="https://www.betterplace.org/de/donate/platform/projects/80075-globalsocial-network?utm_campaign=donate_btn&utm_content=project%2380075&utm_medium=external_banner&utm_source=projects"><img style="border:0px" alt="Donate now! This donation form is provided by betterplace.org." width="160" height="100" src="https://betterplace-assets.betterplace.org/static-images/projects/donation-button-de.png" /></a>-->
    </div>

<!--
    <div v-else class="mt-1 betterplace-widget">
      <iframe frameborder="0" marginheight="0" marginwidth="0" src="https://www.betterplace-widget.org/projects/80255?l=de" width="100%" height="320" style="border: 0; padding:0; margin:0;"><a href='https://www.betterplace.org/de/projects/80075-globalsocial-network' target='_blank'>“GlobalSocial - network”</a> – learn more and donate on betterplace.org.</iframe>
    </div>
    -->

  </section>

</template>

<script>

import RTDonateList from '@/components/RTDonateList.vue'
export default {
  name: 'RTdonate',
  components:{
    RTDonateList
  },
  props:{
    show_header:{
      type:Boolean,
      default:false
    },
    text:{
      type:String,
      default:""
    },
    project:{
      type:Object
    },
    stream_id:{
      type:String
    },
    directDonation:{
      type:Boolean,
      default:false
    },
    show_total_donations:{
      type:Boolean,
      default:true
    },
    limit:{
      type:Number,
      default:-1
    },
    enableStreamNameOption:{
      type:Boolean,
      default:true
    }
  },
  computed:{
  },
  data: function() {
    return {
    };
  },
};
</script>

<style scoped type='text/css'>
.betterplace-widget{
  max-width: 100%;
  width:320px;
  margin:auto;
}
.gsn-donate-button{
    background-color: #efc94c!important;
}
.donate img{
  max-width:200px;
}
</style>